import classNames from "classnames"
import styles from './index.module.sass';

export const SleevesTableHead = () => {
    return (
        <div className={classNames(styles.tableHead, styles.sleeveData)}>
          <div className={classNames(styles.sleeve__col, styles.id)}>
            <span style={{ marginLeft: '20px' }}>id</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.wheatType)}>
            <span>класс и тип пшеницы на вашем складе</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.weight)}>
            <span>вес</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.price)}>
            <span>стоимость</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.perTon)}>
            <span>цена ₽/т</span>
          </div>

          <div className={classNames(styles.sleeve__col, styles.buyer)}>
            <span>покупатель</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.range)}>
            <span>расстояние</span>
          </div>
          <div className={classNames(styles.sleeve__col, styles.netPrice)}>
            <span>НЕТТО (логистика)</span>
          </div>
        </div>
    )
}